import { FunctionComponent, PropsWithChildren } from 'react';

interface TimelineProps extends PropsWithChildren {}

export const Timeline: FunctionComponent<TimelineProps> = ({ children }) => {
  return <div className="flex flex-col">{children}</div>;
};
